import AddSocialHandlesModal from './AddSocialHandlesModal';

export default AddSocialHandlesModal;
